/**
 * Model for passing data to the cohort-task-outputs-chart component
 */
export class TaskOutputsData {
    cohortMaterials: any[] = [];
    selectedCohortMaterials: any[] = [];
    selectedOutputs: any[] = [];
}
